import React from 'react';
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import workspace from "../../../canvas/core/workspace";
import { inchesToMm } from "../../../../helpers/sqftHelper";
import { POINT_PROPERTY } from "../../../../constants";

const SqftSummaryRadii = (props) => {
  const { measureUnit } = props;
  const radii = workspace.getPointProperty(POINT_PROPERTY.arcLength);

  let radiiCounts = {};
  radii.forEach(function(x) {
    radiiCounts[x.value] = (radiiCounts[x.value] || 0) + 1;
  });

  return (
    Object.entries(radiiCounts).map(([radiusName, count]) => {
      let radiusDisplayName = measureUnit === "Imperial" ? radiusName + "\"" : inchesToMm(radiusName) + 'mm';
      return (
        <div className="summary-list__item summary summary--purple" key={radiusName}>
          <div className="summary-title">{"r" + radiusDisplayName}</div>
          <div className="summary-info">
            <div className="summary-info__left">
              <FormattedMessage id="sqft.navigation.summary.amount"/>
              : {count}
            </div>
          </div>
        </div>
      );
    })
  );
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  measureUnit: store.sqftState.measureUnit
});

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(SqftSummaryRadii);
